import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import ChartRedirect from './ChartRedirect';

const NotFound = withLazyFallback(() => import('components/NotFound'));
const Orders = withLazyFallback(() => import('components/practice/charts/Orders/Orders'));
const Actions = withLazyFallback(() => import('components/practice/charts/Actions/Actions'));
const HealthRecordsOrders = withLazyFallback(
  () => import('components/practice/charts/HealthRecords/tabs/Orders/Orders')
);
const HealthRecordsRequests = withLazyFallback(
  () => import('components/practice/charts/HealthRecords/tabs/Requests/Requests')
);

const PRACTICE_CHARTS_ORDERS = [
  {
    path: 'orders',
    element: <Orders />,
    handle: { title: 'Orders' },
    children: [
      { index: true, element: <HealthRecordsOrders /> },
      { path: 'prescriptions', element: <Actions />, handle: { title: 'Prescriptions' } },
      {
        path: 'requests',
        element: <HealthRecordsRequests />,
        handle: { title: 'Referral requests' }
      },
      { path: '*', element: <NotFound /> }
    ]
  },
  { path: 'eprescribe', element: <ChartRedirect to="orders/prescriptions" /> },
  { path: 'health-records/orders', element: <ChartRedirect to="orders" /> },
  { path: 'health-records/requests', element: <ChartRedirect to="orders/requests" /> }
];

export default PRACTICE_CHARTS_ORDERS;
